import request from '@/utils/request'

export function announcementItems (params) {
  return request({
    url: '/amrep/announcement/items',
    method: 'get',
    params
  })
}

export function announcementCreate (data) {
  return request({
    url: '/amrep/announcement/create',
    method: 'post',
    data
  })
}

export function announcementDelete (data) {
  return request({
    url: '/amrep/announcement/delete/' + data.id,
    method: 'delete'
  })
}

export function announcementUpdate (data) {
  return request({
    url: '/amrep/announcement/update',
    method: 'put',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/announcement.js